import { NKDatetimeModule } from 'ng2-datetime/ng2-datetime';
import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { LoginService } from '../../../services/login.service';
import { ModelService } from '../../../services/model.service';
import { GlobalService } from '../../../services/global.service';
import { WindowRef } from '../../../../classes/windowRef';
import { DOCUMENT } from '@angular/platform-browser';
import * as $ from 'jquery';
import swal from 'sweetalert2';

@Component({
  host: { '( document: scroll )': 'onScrollDocument( $event )' },
  selector: 'app-dashboard-admin',
  templateUrl: './dashboard-admin.component.html',
  styleUrls: ['./dashboard-admin.component.scss']
})
export class DashboardAdminComponent implements OnInit {
  @ViewChild( 'scrolledTable' ) scrolledTable;
  @ViewChild( 'fixedTable' ) fixedTable;
  @ViewChild( 'tableWrapper' ) tableWrapper;

	sortingData = {
		field: 			'updated_at',
		direction:  'DESC'
  };

  all_sales: string = '0.00';
  all_profit: string = '0.00';
  referrer_comission: string = '0.00';
  total_comission: string = '0.00';

  scrolledTableOffsetTop = 0;

  extracted_csv = {};

  admins: any[] = [];
  managers: any[] = [];
  clients: any[] = [];
  salespersons: any[] = [];
  nylgReferrers: any[] = [];
  projects: any[] = [];

  isDisabledFilters: boolean = false;
  visibleScrolledTable: boolean = false;

  paginationData = {
  	count: 30,
  	offset: 0,
  	count_all: 0,
  	currentPage: 1,
  	maxPage: 1
  };



  clear_filters = {
    adjustedAmount: '',
    adjustedProfit: '',
    actual_profit: '',
    referrerAmount: '',
    total_comission: '',
    comission_amount: '',
    active: '',
    inactiveProducts: '',
    client: '',
    company: '',
  	discount: '',
    comission_paid: '',
  	Name: '',
    sales: '',
    invoice: '',
    proposal: '',
    purchase: '',
  	deadline: '',
    status: '',
    owner: '',
    manager: '',
    balance: '',
    ProductCost: '',
    daysDue: '',
    dueTotal: '',
    rebateAmount: '',
    totalAmountAfterRebate: '',
    taxAmount: '',
    Deposit: '',
  	Profit: '',
    jobType: '',
    BuildingType: '',
  	NYLG_referrer: '',
    projected_profit: '',
    fromDate: '',
    toDate: ''
  };

  filtersData = this.clear_filters;

  clearFilters ( ) {
    this.filtersData = this.clear_filters;
    this._date_deadline = '';
    this._date_from = '';
    this._date_to = '';
    this.sortingData = {
      field:       'updated_at',
      direction:   'DESC'
    };
    this.changeFilters( true );
  }

	projectsData = [];
	projectStatuses = {
    newLead: 'New lead',
    leadLost: 'Lead lost',
    pendingManagerApproval: 'Pending manager approval',
    managerApproved: 'Manager approved',
    proposalSent: 'Proposal sent',
    invoiceSent: 'Invoice sent',
    purchaseOrderSent: 'Purchase order sent',
    productsShipped: 'Products shipped',
    productsReceived: 'Products received',
    depositReceived: 'Deposit received',
    installationPending: 'Installation pending',
    installationCompleted: 'Installation completed',
    paidInFull: 'Paid in full',
    projectCompleted: 'Project completed',
    projectCompletedRMARGA: 'Project completed with RMA/RGA',
    projectCancelled: 'Project cancelled',
    other: 'Other'
	};


  projectJobTypes = {
    repair: "Repair",
    retrofit: "Retrofit",
    newInstall: "Non-retrofit"
  };

  projectBuildingTypes = {
    bank: "Bank",
    commercialBuilding: "Commercial building",
    educationalInstitution: "Educational institution",
    hospitality: "Hospitality",
    hospitalHealthcare: "Hospital / Healthcare",
    massTransit: "Mass transit",
    parkingLot: "Parking lot",
    residentialBuilding: "Residential building",
    restaurant: "Restaurant",
    retailStore: "Retail store",
    supermarket: "Supermarket",
    warehouse: "Warehouse",
    other: "Other"
  };

  filtersTimeout: any;

	contentVisible: boolean = false;

  availableRoles: string[] = [ 'admin', 'manager' ];
  isAvailable: boolean = true;

  datepickerExportFromOptions = {
    hideIcon: true,
    format: 'mm/dd/yyyy',
    placeholder: 'from'
  };
  datepickerExportToOptions = {
    hideIcon: true,
    format: 'mm/dd/yyyy',
    placeholder: 'to'
  };

  datepickerFromOptions = {
    hideIcon: true,
    format: 'mm/dd/yyyy',
    placeholder: 'from'
  };
  datepickerToOptions = {
    hideIcon: true,
    format: 'mm/dd/yyyy',
    placeholder: 'to'
  };
  datepickerDeadlineOptions = {
    hideIcon: true,
    format: 'mm/dd/yyyy',
    placeholder: 'deadline'
  };

  _date_from: any = '';
  _date_to: any = '';
  _old_from: any = ''
  _old_to: any = '';
  _was_matched_from: boolean = false;
  _was_matched_to: boolean = false;
  _date_deadline: any = '';
  _old_deadline: any = ''
  _was_matched_deadline: boolean = false;

  _scrollTop:number = 0;
  _scrollTopTimer:any = null;
  _scrollSystemInit: boolean = false;


  selectWidth: number = 160;

  reloadInterval: any;

  active_count: number = 0;

  selectParams: any = {

    //ToDo rewrite
    client: {
      id: 'selectClient',
      isDisabled: this.isDisabledFilters,
      change: ( event ) => { 
        this.filtersData.client = event.value; 
        this.changeFilters( );
      },
      options: [ { text: '', value: '' } ]
    },

    company: {
      id: 'selectCompany',
      isDisabled: this.isDisabledFilters,
      change: ( event ) => {
        this.filtersData.company = event.value;
        this.changeFilters( );
      },
      options: [ { text: '', value: '' } ]
    },
    
    name: {
      id: 'selectName',
      isDisabled: this.isDisabledFilters,
      change: ( event ) => { 
        this.filtersData.Name = event.value; 
        this.changeFilters( );
      },
      options: [ { text: '', value: '' } ]
    },
    
    status: {
      id: 'selectStatus',
      isDisabled: this.isDisabledFilters,
      change: ( event ) => { 
        this.filtersData.status = event.value; 
        this.changeFilters( );
      },
      options: [ 
        { text: '', value: '' },
        { value: "newLead", text: 'New lead' },
        { value: "leadLost", text: 'Lead lost' },
        { value: "pendingManagerApproval", text: 'Pending manager approval' },
        { value: "managerApproved", text: 'Manager approved' },
        { value: "proposalSent", text: 'Proposal sent' },
        { value: "depositReceived", text: 'Deposit received' },
        { value: "invoiceSent", text: 'Invoice sent' },
        { value: "purchaseOrderSent", text: 'Purchase order sent' },
        { value: "productsShipped", text: 'Products shipped' },
        { value: "productsReceived", text: 'Products received' },
        { value: "paidInFull", text: 'Paid in full' },
        { value: "installationPending", text: 'Installation pending' },
        { value: "installationCompleted", text: 'Installation completed' },
        { value: 'projectCompleted', text: 'Project completed' },
        { value: 'projectCompletedRMARGA', text: 'Project completed with RMA/RGA' },
        { value: 'projectCancelled', text: 'Project cancelled' },
        { value: "other", text: 'Other' }
      ]
    },

    active: {
      id: 'selectActive',
      isDisabled: this.isDisabledFilters,
      change: ( event ) => { 
        this.filtersData.active = event.value; 
        this.changeFilters( );
      },
      options: [ 
        { text: '', value: '' },
        { text: 'Active', value: 'true' },
        { text: 'Inactive', value: 'false' }
      ]
    },

    inactiveProducts: {
      id: 'selectInactiveProducts',
      isDisabled: this.isDisabledFilters,
      change: ( event ) => { 
        this.filtersData.inactiveProducts = event.value; 
        this.changeFilters( );
      },
      options: [ 
        { text: '', value: '' },
        { text: 'Yes', value: 'true' },
        { text: 'No', value: 'false' }
      ]
    },

    comissionPaid: {
      id: 'selectCommissionPaid',
      isDisabled: this.isDisabledFilters,
      change: ( event ) => { 
        this.filtersData.comission_paid = event.value; 
        this.changeFilters( );
      },
      options: [ 
        { text: '', value: '' },
        { text: 'Yes', value: 'true' },
        { text: 'No', value: 'false' }
      ]
    },

    jobType: {
      id: 'selectJobType',
      isDisabled: this.isDisabledFilters,
      change: ( event ) => { 
        this.filtersData.jobType = event.value; 
        this.changeFilters( );
      },
      options: [ 
        { text: '', value: '' },
        { text: 'Repair', value: 'repair' },
        { text: 'Retrofit', value: 'retrofit' },
        { text: 'Non-retrofit', value: 'newInstall' }
      ]
    },

    buildingType: {
      id: 'selectBuildingType',
      isDisabled: this.isDisabledFilters,
      change: ( event ) => { 
        this.filtersData.BuildingType = event.value; 
        this.changeFilters( );
      },
      options: [ 
        { text: '', value: '' },
        { text: 'Bank', value: 'bank' },
        { text: 'Commercial building', value: 'commercialBuilding' },
        { text: 'Educational institution', value: 'educationalInstitution' },
        { text: 'Hospitality', value: 'hospitality' },
        { text: 'Hospital / Healthcare', value: 'hospitalHealthcare' },
        { text: 'Mass transit', value: 'massTransit' },
        { text: 'Parking lot', value: 'parkingLot' },
        { text: 'Residential building', value: 'residentialBuilding' },
        { text: 'Restaurant', value: 'restaurant' },
        { text: 'Retail store', value: 'retailStore' },
        { text: 'Supermarket', value: 'supermarket' },
        { text: 'Warehouse', value: 'warehouse' },
        { text: 'Other', value: 'other' }
      ]
    },

    deposit: {
      id: 'selectDepositType',
      isDisabled: this.isDisabledFilters,
      change: ( event ) => { 
        this.filtersData.Deposit = event.value; 
        this.changeFilters( );
      },
      options: [ 
        { text: '', value: '' },
        { text: 'Yes', value: 'Yes' },
        { text: 'No', value: 'No' }
      ]
    },

    owner: {
      id: 'selectOwner',
      isDisabled: this.isDisabledFilters,
      change: ( event ) => { 
        this.filtersData.owner = event.value; 
        this.changeFilters( );
      },
      options: [ { text: '', value: '' } ]
    },

    nylgReferrers: {
      id: 'selectNYLGRefs',
      isDisabled: this.isDisabledFilters,
      change: ( event ) => { 
        this.filtersData.NYLG_referrer = event.value; 
        this.changeFilters( );
      },
      options: [ { text: '', value: '' } ]
    },

    sales: {
      id: 'selectSales',
      isDisabled: this.isDisabledFilters,
      change: ( event ) => { 
        this.filtersData.sales = event.value; 
        this.changeFilters( );
      },
      options: [ { text: '', value: '' } ]
    },

    manager: {
      id: 'selectManager',
      isDisabled: this.isDisabledFilters,
      change: ( event ) => { 
        this.filtersData.manager = event.value; 
        this.changeFilters( );
      },
      options: [ { text: '', value: '' } ]
    }

  };


  constructor ( 
    @Inject(DOCUMENT) private document: Document,
    private model: ModelService,
    private winRef: WindowRef,
    private global: GlobalService,
    public loginService: LoginService ) {
    this.global.setDocumentTitle( 'Dashboard' ); 
    if ( this.availableRoles.indexOf( this.loginService.userInfo.role ) === -1 ) this.isAvailable = false;
    else this.isAvailable = true;
  }

  
  ngOnInit( ) {
    this.reloadInterval = setInterval( ( ) => {
      this.loadData( true, (active_count) => {
        if (active_count > this.active_count) {

          let data = {
            type: 'success',
            title: 'Success',
            html: (active_count-this.active_count) + ' new project(s) have been created in the past 5 minutes',
            showConfirmButton: true
          }
          this.global.successMessage( data );
          setTimeout( ( ) => { 
            swal.close( ); 
          }, 1000 * 2 * 60 ); // 5 minutes delay

        }
        this.active_count = active_count;
      });

    }, 1000 * 5 * 60 ); // 5 minutes interval


    this.model.getUsersData( ( usersData ) => {
      usersData = usersData.json( ).users;
      this.admins = usersData;
      usersData.forEach( _ad => { this.selectParams.owner.options.push( { text: _ad.firstName + ' ' + _ad.secondName, value: _ad.id } ); });
    });

    this.model.getClientsData( ( clientsData ) => {
      this.clients = clientsData;
      clientsData.forEach( _cl => {
        this.selectParams.client.options.push( { text: _cl.FirstName + ' ' + _cl.LastName, value: _cl.id } );
        this.selectParams.company.options.push( { text: _cl.Company, value: _cl.id } );
      });
      this.selectParams.company.options.sort();
    }, 'Company' );

    this.model.getUsersData( ( usersData ) => {
      usersData = usersData.json( );
      this.salespersons = usersData.users;
      usersData.users.forEach( _sp => { 
        this.selectParams.sales.options.push( { text: _sp.firstName + ' ' + _sp.secondName, value: _sp.id } ); 
        if ( _sp.role != 'installer' && _sp.role != 'referrer' ) {
          this.nylgReferrers.push( _sp );
          this.selectParams.nylgReferrers.options.push( { text: _sp.firstName + ' ' + _sp.secondName, value: _sp.id } ); 
        }
      });
    }, { status: 'active', not_empty_name: 'true' });


    this.model.getProjectsListData( ( prData ) => {
      prData = prData.json( );
      this.projects = prData.projects;
      prData.projects.forEach( _pr => { this.selectParams.name.options.push( { text: _pr.Name, value: _pr.id } ); });
    });

    if ( this.loginService.userInfo.role == 'admin' ) {
      this.model.getUsersData( ( usersData ) => {
        usersData = usersData.json( );
        this.managers = usersData.users;
        usersData.users.forEach( _mg => { this.selectParams.manager.options.push( { text: _mg.firstName + ' ' + _mg.secondName, value: _mg.id } ); });
      }, { manager: 'manager', status: 'active', not_empty_name: 'true' });
    }

  }

  _scrollIntoView ( ) {
    // Code to scroll window
    setTimeout( ( ) => {
      this.winRef.nativeWindow.scrollTo( 0, this._scrollTop );
    }, 1500 );
  }

  ngAfterViewInit ( ) {
    let _sorting = localStorage.getItem( 'sortingAdminDashboard' );
    let _filters = localStorage.getItem( 'filtersAdminDashboard' );
    let _pagination = localStorage.getItem( 'paginationAdminDashboard' );
    let _scroll = localStorage.getItem( 'scrollAdminDashboard' );
    if ( _sorting ) this.sortingData = JSON.parse( _sorting );
    if ( _filters ) this.filtersData = JSON.parse( _filters );
    if ( _pagination ) this.paginationData = JSON.parse( _pagination );
    if ( _scroll ) this._scrollTop = +_scroll;
    if ( this.filtersData.deadline || this.filtersData.deadline === '' ) this._date_deadline = this.global.parseDate( this.filtersData.deadline );
    if ( this.filtersData.fromDate || this.filtersData.fromDate === '' ) this._date_from = this.global.parseDate( this.filtersData.fromDate );
    if ( this.filtersData.toDate || this.filtersData.toDate === '' ) this._date_to = this.global.parseDate( this.filtersData.toDate );
    this.loadData( null, (active_count) => {
      this._scrollIntoView( );
      this.active_count = active_count; 
    });
  }

  onScrollDocument ( event ) {

    clearTimeout( this._scrollTopTimer );
    this._scrollTopTimer = setTimeout( ( ) => {
      if ( this._scrollSystemInit || this._scrollTop != 0 ) {
        localStorage.setItem( 'scrollAdminDashboard', this.winRef.nativeWindow.scrollY );
      } else {
        this._scrollSystemInit = true;
      }
    }, 350);

    let headerHeight = 71;
    let _wrapper = this.document.getElementsByClassName('scrolled-table--wrapper')[0];

    // Fixing of header height
    if ( this.global.displayWidth < 768 ) headerHeight = 51;

    if ( this.fixedTable && this.tableWrapper ) {
      if ( event.target.scrollingElement.scrollTop > headerHeight + this.tableWrapper.nativeElement.offsetTop ) {
        this.visibleScrolledTable = true;
        if ( _wrapper ) _wrapper.scrollLeft = this.tableWrapper.nativeElement.scrollLeft;
      } else {
        this.visibleScrolledTable = false;
      }
    } else {
      this.visibleScrolledTable = false;
    }
    
  }

  onHorizontalScroll ( event ) {

    if ( this.scrolledTable && this.fixedTable && this.tableWrapper ) {
      this.document.getElementsByClassName('scrolled-table--wrapper')[0].scrollLeft = this.tableWrapper.nativeElement.scrollLeft;
    }

  }

  projectRedirect ( id ) {
  	this.global.redirect( '/project-detail/'+id );
  }

  changeSorting ( _sortField ) {

  	if ( _sortField != this.sortingData.field ) {
  		this.sortingData.field = _sortField;
  		this.sortingData.direction = 'ASC';
  	} else {
  		this.sortingData.direction = ( this.sortingData.direction == 'ASC' ) ? 'DESC' : 'ASC';
  	}

    this.paginationData.offset = 0;
    this.paginationData.currentPage = 1;

    localStorage.setItem( 'sortingAdminDashboard', JSON.stringify( this.sortingData ) );
    localStorage.setItem( 'paginationAdminDashboard', JSON.stringify( this.paginationData ) );

  	this.loadData( );

  }

  changeFilters ( clearing?:boolean ) {

    clearTimeout( this.filtersTimeout );
    this.filtersTimeout = setTimeout( ( ) => {
      this.paginationData.offset = 0;
      this.paginationData.currentPage = 1;
      if ( clearing !== true ) {
        localStorage.setItem( 'filtersAdminDashboard', JSON.stringify( this.filtersData ) );
        localStorage.setItem( 'paginationAdminDashboard', JSON.stringify( this.paginationData ) );
      } else {
        localStorage.removeItem( 'sortingAdminDashboard' );
        localStorage.removeItem( 'filtersAdminDashboard' );
        localStorage.removeItem( 'paginationAdminDashboard' );
      }
      // this.isDisabledFilters = true;
      if ( clearing == true ) this.loadData( false );
      else this.loadData( );
    }, 350 );

  }

  changePage ( page ) {
  	this.paginationData.currentPage = page;
  	this.paginationData.offset = (page-1) * this.paginationData.count;
    localStorage.setItem( 'paginationAdminDashboard', JSON.stringify( this.paginationData ) );
  	this.loadData( false );
    $('html,body').animate({ scrollTop: 0 }, 'slow');
  }

  handleDateFromChange ( $event ) {
    if ( $event === undefined ) return;
    let _date = ( $event.getMonth( ) + 1 ) + '/' + $event.getDate( ) + '/' + $event.getFullYear( );

    this.filtersData.fromDate = _date;
    this._old_from = _date;
    this._was_matched_from = true;
    this.changeFilters( );
  }
  handleDateToChange ( $event ) {
    if ( $event === undefined ) return;
    let _date = ( $event.getMonth( ) + 1 ) + '/' + $event.getDate( ) + '/' + $event.getFullYear( );

    this.filtersData.toDate = _date;
    this._old_to = _date;
    this._was_matched_to = true;
    this.changeFilters( );
  }
  handleDateDeadlineChange ( $event ) {
    if ( $event === undefined ) return;
    let _date = ( $event.getMonth( ) + 1 ) + '/' + $event.getDate( ) + '/' + $event.getFullYear( );

    this.filtersData.deadline = _date;
    this._old_deadline = _date;
    this._was_matched_deadline = true;
    this.changeFilters( );
  }

  changeDatePickerFrom ( _value, _ref ) {
    if ( _value === undefined ) return;
    _ref.filtersData.fromDate = '';
    
    if ( _value.match( /^(?:(?:(?:0?[13578]|1[02])(\/|-|\.)31)\1|(?:(?:0?[1,3-9]|1[0-2])(\/|-|\.)(?:29|30)\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:0?2(\/|-|\.)29\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:(?:0?[1-9])|(?:1[0-2]))(\/|-|\.)(?:0?[1-9]|1\d|2[0-8])\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/ ) ) {
      if ( _value != _ref._old_from ) {
        _ref._old_from = _value;
        _ref._was_matched_from = true;
        _ref.filtersData.fromDate = _value;
        _ref.changeFilters( );
      }
    } else {
      if ( _ref._was_matched_from == true ) {
        _ref._old_from = _value;
        _ref._was_matched_from = false;
        _ref.changeFilters( );
      }
    }
  }
  changeDatePickerTo ( _value, _ref ) {
    if ( _value === undefined ) return;

    _ref.filtersData.toDate = '';
    
    if ( _value.match( /^(?:(?:(?:0?[13578]|1[02])(\/|-|\.)31)\1|(?:(?:0?[1,3-9]|1[0-2])(\/|-|\.)(?:29|30)\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:0?2(\/|-|\.)29\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:(?:0?[1-9])|(?:1[0-2]))(\/|-|\.)(?:0?[1-9]|1\d|2[0-8])\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/ ) ) {
      if ( _value != _ref._old_to ) {
        _ref._old_to = _value;
        _ref._was_matched_to = true;
        _ref.filtersData.toDate = _value;
        _ref.changeFilters( );
      }
    } else {
      if ( _ref._was_matched_to == true ) {
        _ref._old_to = _value;
        _ref._was_matched_to = false;
        _ref.changeFilters( );
      }
    }
  }
  changeDatePickerDeadline ( _value, _ref ) {
    if ( _value === undefined ) return;

    _ref.filtersData.deadline = '';
    
    if ( _value.match( /^(?:(?:(?:0?[13578]|1[02])(\/|-|\.)31)\1|(?:(?:0?[1,3-9]|1[0-2])(\/|-|\.)(?:29|30)\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:0?2(\/|-|\.)29\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:(?:0?[1-9])|(?:1[0-2]))(\/|-|\.)(?:0?[1-9]|1\d|2[0-8])\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/ ) ) {
      if ( _value != _ref._old_deadline ) {
        _ref._old_deadline = _value;
        _ref._was_matched_deadline = true;
        _ref.filtersData.deadline = _value;
        _ref.changeFilters( );
      }
    } else {
      if ( _ref._was_matched_deadline == true ) {
        _ref._old_deadline = _value;
        _ref._was_matched_deadline = false;
        _ref.changeFilters( );
      }
    }
  }

  loadData ( _withoutPreloader?, cb? ) {
  	let requestData = {};
    let withoutPreloader = true;
    if ( _withoutPreloader === false ) withoutPreloader = false;

  	requestData['sorting'] = this.sortingData;
  	requestData['pagination'] = this.paginationData;
  	requestData['filters'] = this.filtersData;
    
    this.model.getAdminDashboardData( requestData, ( response ) => {
      // this.isDisabledFilters = false;
      this.contentVisible = true;
      // this.checkEqualityFilters( response.filters );
      this.extracted_csv = response.extracted_csv || {};
      this.projectsData = response.data;
      this.sortingData = response.sorting;
      this.paginationData = response.pagination;
      this.filtersData = response.filters;
      this.all_sales = response.AllProductCost;
      this.all_profit = response.all_profit;
      this.referrer_comission = response.referrer_comission;
      this.total_comission = response.total_comission;
      if (+this.total_comission == 0) this.total_comission = '0.00';
      if ( cb ) cb( response.active_count );
  	}, withoutPreloader);
  }

  // checkEqualityFilters ( filters ) {

  //   let isEqual = true;

  //   for ( let item in filters ) {
  //     if ( this.filtersData[item] != filters[item] ) {
  //       isEqual = false;
  //       break;
  //     }
  //   }

  //   if ( !isEqual ) this.loadData( );

  // }

  ngOnDestroy( ) {
    clearInterval( this.reloadInterval );
  }

}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/defaults/dashboard-admin/dashboard-admin.component.ts